import React from 'react'
import { NumberFormat } from '@lingui/react';
import format from 'date-fns/format';

const RenderGiacenze = ({ giacenze }) => {
    if (!giacenze) {
        return null
    }

    const giacenzeData = giacenze.giacenze
    if (!giacenzeData) {
        return null
    }

    const mainLabel = giacenzeData.label?.['it_IT'] || 'Giacenze'
    const children = giacenzeData.children || []

    if (children.length === 0) {
        return null
    }

    // Determina se è single row o multiple rows
    // Single row: children è array di oggetti [{giacenza}, {data_giacenza}]
    // Multiple rows: children è array di array [[{giacenza}, {data_giacenza}], [...], ...]
    const isMultipleRows = Array.isArray(children[0])

    // Normalizza le righe: se single row wrappa in array
    const rows = isMultipleRows ? children : [children]

    return (
        <div className="section-integrations container-full-width overflow-hidden">
            <table className="table table-striped table-striped-alt table-hover table-article-info">
                <tbody>
                    {rows.map((rowItems, index) => {
                        const giacenzaItem = rowItems.find(item => item.property === 'giacenza')
                        const dataGiacenzaItem = rowItems.find(item => item.property === 'data_giacenza')

                        return (
                            <>
                                <tr key={index}>
                                    <td>Quantità</td>
                                    <td>
                                        <strong>
                                            <NumberFormat
                                                value={giacenzaItem?.value ?? 0}
                                            />
                                            </strong>
                                    </td>
                                </tr>

                                <tr key={index}>
                                    <td>Data Giacenza</td>
                                    <td>
                                        <strong>
                                            {(
                                                dataGiacenzaItem?.value ?
                                                    format(dataGiacenzaItem?.value, 'DD/MM/YYYY') : '-'
                                            )}
                                            </strong>
                                    </td>
                                </tr>
                            </>

                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default RenderGiacenze